import { createSlice } from '@reduxjs/toolkit';
import { ISkill } from '../../../../dto';
import { setSkills } from '../actions';
import { MN_SKILLS, TYPE_LIST } from '../../../../common';

export interface SkillsState {
  data: ISkill[];
  loading: boolean;
  error: string | null;
}

const initialState: SkillsState = {
  data: [],
  loading: false,
  error: null,
};

export const skillsSlice = createSlice({
  name: `${MN_SKILLS}/${TYPE_LIST}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setSkills, (state, { payload }) => {
      state.data = payload;
    });
  },
});
